// extracted by mini-css-extract-plugin
export default {"formContainer":"emotion-editor_formContainer__drxo4"};